module.exports = __webpack_public_path__ + "img/202501160102.ce798171.png";